import { useState } from "react"
import Switch from "@mui/material/Switch"
import CircularProgress from "@mui/material/CircularProgress"
import Stack from "@mui/material/Stack"
import { patchWorkspaceGenerateCsvColumnCatalog } from "@/src/services/internal"
import { useInternalStore } from "@/src/store"

type WorkspaceGenerateCsvColumnCatalogToggleProps = {
    workspaceId: string
    enabled: boolean
}

export function WorkspaceGenerateCsvColumnCatalogToggle({
    workspaceId,
    enabled,
}: WorkspaceGenerateCsvColumnCatalogToggleProps) {
    const setWorkspaceGenerateCsvColumnCatalogEnabled = useInternalStore(
        (state) => state.setWorkspaceGenerateCsvColumnCatalogEnabled
    )
    const [isUpdating, setIsUpdating] = useState(false)

    const handleToggleChange = async (nextEnabled: boolean) => {
        if (isUpdating) return

        setIsUpdating(true)
        setWorkspaceGenerateCsvColumnCatalogEnabled(workspaceId, nextEnabled)

        try {
            await patchWorkspaceGenerateCsvColumnCatalog(workspaceId, nextEnabled)
        } catch {
            setWorkspaceGenerateCsvColumnCatalogEnabled(workspaceId, enabled)
        } finally {
            setIsUpdating(false)
        }
    }

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            onClick={(event) => event.stopPropagation()}
        >
            {isUpdating ? (
                <CircularProgress size={24} />
            ) : (
                <Switch
                    checked={enabled}
                    onChange={(event) => handleToggleChange(event.target.checked)}
                    color="primary"
                    inputProps={{ "aria-label": "Generate CSV column catalog" }}
                />
            )}
        </Stack>
    )
}
